// extracted by mini-css-extract-plugin
module.exports = {"table":"FlexTable_table__3MeRX","head":"FlexTable_head__1zHin","body":"FlexTable_body__3uHxx","row":"FlexTable_row__nms3E","cell":"FlexTable_cell__2HXtg"};